export interface IConfiguracao {
  id?: number;
  valorVenda?: number | null;
  prazoAprovacaoNota?: number | null;
  quantidadePossivelVenda?: number | null;
  percentProdutor?: number | null;
}

export class Configuracao implements IConfiguracao {
  constructor(public id?: number, public valorVenda?: number | null,
    public prazoAprovacaoNota?: number | null,
    public quantidadePossivelVenda?: number | null,
    public percentProdutor?: number | null) {}
}

export function getConfiguracaoIdentifier(configuracao: IConfiguracao): number | undefined {
  return configuracao.id;
}
